import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from '@app/core/interceptors/auth.interceptor';
import { errorInterceptor } from '@app/core/interceptors/error.interceptor';
import { faroInitializer } from '@app/core/observability/faro-initializer';
import { FaroErrorHandler } from '@app/core/observability/faro-error-handler';
import { FaroUserTracker } from '@app/core/observability/faro-user-tracker.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(faroInitializer()),
    // Eagerly construct the tracker so its currentUser effect runs from startup.
    provideAppInitializer(() => {
      inject(FaroUserTracker);
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    { provide: ErrorHandler, useClass: FaroErrorHandler },
  ],
};
